module.exports = __webpack_public_path__ + "img/kbank.e06178b9.svg";